import PortfolioRedirect from './portfolio-redirect';
export default PortfolioRedirect;